import React, { useEffect } from 'react';
import { Form, Input, Typography, Select } from 'antd';
import DocUploadInFRS from '../Labs&Research/DocUploadInFR';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

interface TaskInfoProps {
  form: any;
  type: 'edit' | 'create' | 'view';
  departmentOptions: any[];
  nompayId: number | null;
  documents: any[];
  status: string | null;
}

const TaskInfo: React.FC<TaskInfoProps> = ({ form, type, departmentOptions, nompayId, documents, status }) => {
  const isViewMode = type === 'view';
  useEffect(() => {
    console.log('TaskInfo Documents received from parent:', documents);
  }, [form]);

  return (
    <>
      <Form form={form} name="TaskInfoForm" layout="vertical" disabled={isViewMode}>
        <BaseRow gutter={[16, 16]}>
          <BaseCol xs={24} md={8} lg={12}>
            <Form.Item
              label="Department"
              name="department"
              rules={[{ required: true, message: 'Please select a department' }]}
            >
              <BaseSelect placeholder="Select Department">
                {departmentOptions.map((dept) => (
                  <Select.Option key={dept.value} value={dept.value}>
                    {dept.label}
                  </Select.Option>
                ))}
              </BaseSelect>
            </Form.Item>
          </BaseCol>
        </BaseRow>
        <Form.Item label="Additional Description" name="description">
          <Input.TextArea rows={4} placeholder="Enter any additional notes or description here..." />
        </Form.Item>
        {(status === 'DRAFT' || status === 'DONE') && (
          <>
            <Typography.Title level={5} style={{ marginTop: 24 }}>
              Add any relevant documents here
            </Typography.Title>
            <DocUploadInFRS Id={nompayId} initialFiles={documents} />
          </>
        )}
      </Form>
    </>
  );
};

export default TaskInfo;
